// extracted by mini-css-extract-plugin
export default {"main":"subhome_main__-arS9","img":"subhome_img__Jqawv","content":"subhome_content__3-kws","voyah":"subhome_voyah__eqL9c"};